import { lazy } from "react";

/** Pages */
const Profile = lazy(() => import("../pages/profile/Profile"));
const Settings = lazy(() => import("@gyandiksha/profile/components/StudentSettings"));
const EditProfile = lazy(() => import("../pages/editProfile/EditProfile"));
const CompanyList = lazy(() => import("../pages/companyList/CompanyList"));
const AddEditCompany = lazy(() => import("../pages/companyList/feature/addEditCompany/AddEditCompany"));
const ViewCompany = lazy(() => import("../pages/companyList/feature/viewCompany/ViewCompany"));
const PlacementManagement = lazy(() => import("../pages/placementManagement/PlacementManagement"));
const AddPlacement = lazy(() => import("../pages/placementManagement/feature/addPlacement/AddPlacement"));
const ViewPlacement = lazy(() => import("../pages/placementManagement/feature/viewPlacement/ViewPlacement"));
const JobOpportunities = lazy(() => import("../pages/jobOpportunities/JobOpportunities"));
const ViewJobPost = lazy(() => import("../pages/jobOpportunities/feature/viewJobPost/ViewJobPost"));
const ApplyJobPost = lazy(() => import("../pages/jobOpportunities/feature/applyJobPost/ApplyJobPost"));
const StudentApplicants = lazy(() => import("../pages/placementManagement/feature/studentApplicants/StudentApplicants"));
const ViewStudentApplication = lazy(() => import("../pages/placementManagement/feature/studentApplicants/feature/viewStudentApplication/ViewStudentApplication"));
const StudentApplicationFlow = lazy(() => import("../pages/studentApplicationFlow/StudentApplicationFlow"));
const StudentView = lazy(() => import("../pages/studentView/StudentView"));

const ComponentNavigation = [
    // {
    //     id: "dashboard",
    //     path: "/dashboard",
    //     exact: true,
    //     title: "",
    //     component: Dashboard,
    //     hasParams: false,
    //     text: "Dashboard Page"
    // },
    {
        id: "profile",
        path: "/profile",
        exact: true,
        title: "",
        component: Profile,
        hasParams: false,
        text: "My Profile"
    },
    {
        id: "company-list",
        path: "/company-list",
        exact: true,
        title: "",
        component: CompanyList,
        hasParams: false,
        text: "Company List"
    },
    {
        id: "add-company",
        path: "/company-list/add",
        exact: true,
        title: "",
        component: AddEditCompany,
        hasParams: false,
        text: "Add/Edit Company"
    },
    {
        id: "edit-company-profile",
        path: "/profile/edit-company",
        exact: true,
        title: "",
        component: AddEditCompany,
        hasParams: false,
        text: "Edit Company"
    },
    {
        id: "view-company",
        path: "/company-list/view/:companyId",
        exact: true,
        title: "",
        component: ViewCompany,
        hasParams: true,
        text: "Company Details"
    },
    {
        id: "placement-management",
        path: "/placement-management",
        exact: true,
        title: "",
        component: PlacementManagement,
        hasParams: false,
        text: "Placement Management"
    },
    {
        id: "add-placement",
        path: "/placement-management/add",
        exact: true,
        title: "",
        component: AddPlacement,
        hasParams: false,
        text: "Add/Edit Placement Drive"
    },
    {
        id: "view-placement",
        path: "/placement-management/view/:postId",
        exact: true,
        title: "",
        component: ViewPlacement,
        hasParams: true,
        text: "View Job Posting"
    },
    {
        id: "placement-student-applicants",
        path: "/placement-management/applicants/:postId",
        exact: true,
        title: "",
        component: StudentApplicants,
        hasParams: true,
        text: "Student Applicants"
    },
    {
        id: "student-view",
        path: "/student-view",
        exact: true,
        title: "",
        component: StudentView,
        hasParams: false,
        text: "Student View"
    },
    {
        id: "view-placement-details",
        path: "/view-placement-details",
        exact: true,
        title: "",
        component: ViewStudentApplication,
        hasParams: true,
        text: "View Student Application"
    },
    {
        id: "student-view",
        path: "/student-view",
        exact: true,
        title: "",
        component: StudentView,
        hasParams: false,
        text: "Student View"
    },
    {
        id: "job-opportunities",
        path: "/job-opportunities",
        exact: true,
        title: "",
        component: JobOpportunities,
        hasParams: false,
        text: "Job Opportunities"
    },
    {
        id: "apply-job-post",
        path: "/job-opportunities/apply",
        exact: true,
        title: "",
        component: ApplyJobPost,
        hasParams: false,
        text: "Apply for Placement"
    },
    {
        id: "view-job-post",
        path: "/job-opportunities/:postId",
        exact: true,
        title: "",
        component: ViewJobPost,
        hasParams: true,
        text: "Placement Drive Details"
    },
    {
        id: "my-applications",
        path: "/my-applications",
        exact: true,
        title: "",
        component: StudentApplicationFlow,
        hasParams: false,
        text: "My Applications"
    },
    {
        id: "my-application-view",
        path: "/my-applications/:postId",
        exact: true,
        title: "",
        component: ViewJobPost,
        hasParams: true,
        text: "Application Details"
    },
    {
        id: "edit-profile",
        path: "/edit-profile",
        exact: true,
        title: "",
        component: EditProfile,
        hasParams: false,
        text: "Edit Profile",
    },
    {
        id: "settings",
        path: "/settings",
        exact: true,
        title: "",
        component: Settings,
        hasParams: false,
        text: "Settings"
    }
];

export default ComponentNavigation;
